export const Colors = {
    darkBlue: "#113558",
    primaryRed: "#FF001F",
    primaryBlue: "#3C6FB0",
    successGreen: "#347B43",
    lightGray: "#F2F2F2",
    darkGray2: "#415C66",
    errorRed: "#B40000",
    errorRedBg: "#FDA2A2",
    lightestBlue: "#D7E3F5"
};
